import { render } from "./SummaryPage.vue?vue&type=template&id=5507095a&scoped=true"
import script from "./SummaryPage.vue?vue&type=script&lang=js"
export * from "./SummaryPage.vue?vue&type=script&lang=js"

import "./SummaryPage.vue?vue&type=style&index=0&id=5507095a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5507095a"]])

export default __exports__